// Animación de éxito global (palomita verde que se dibuja sola, con pop tipo
// resorte). Se monta UNA vez en App y cualquier página la dispara con
// showSuccess({ title, subtitle, cta }). Reemplaza los toasts verdes "básicos"
// con un feedback premium y consistente en toda la tienda.
// Estilos (.mq-check-*, .mq-scrim) viven en index.css.
import { useEffect, useState } from "react";
import { motion, useReducedMotion } from "framer-motion";

let listeners = [];
export function showSuccess(opts) {
  listeners.forEach((fn) => fn(opts || {}));
}

export default function SuccessOverlay() {
  const [data, setData] = useState(null);
  const reduced = useReducedMotion();
  useEffect(() => {
    const fn = (o) => setData(o);
    listeners.push(fn);
    return () => { listeners = listeners.filter((x) => x !== fn); };
  }, []);
  useEffect(() => {
    if (!data) return undefined;
    const t = setTimeout(() => setData(null), 2200);
    return () => clearTimeout(t);
  }, [data]);
  if (!data) return null;
  const close = () => setData(null);
  return (
    <div role="dialog" aria-label={data.title || "Listo"} className="mq-scrim fixed inset-0 z-[70] grid place-items-center bg-slate-900/40 backdrop-blur-sm p-4" onClick={close}>
      <motion.div onClick={(e) => e.stopPropagation()}
        initial={reduced ? { opacity: 0 } : { opacity: 0, scale: 0.9, y: 10 }}
        animate={reduced ? { opacity: 1 } : { opacity: 1, scale: 1, y: 0 }}
        transition={reduced ? { duration: 0.2 } : { type: "spring", bounce: 0.28, duration: 0.5 }}
        className="bg-white rounded-3xl shadow-2xl px-8 py-8 flex flex-col items-center text-center max-w-[300px] w-full">
        <div className="mq-check-disc grid place-items-center">
          <svg viewBox="0 0 72 72" className="w-14 h-14" aria-hidden="true">
            <circle className="mq-check-circle" cx="36" cy="36" r="33" />
            <path className="mq-check-mark" d="M22 37.5 l9.5 9.5 l18.5 -22" />
          </svg>
        </div>
        <h3 className="mt-5 font-head text-xl font-extrabold text-slate-900">{data.title || "¡Listo!"}</h3>
        {data.subtitle && <p className="mt-1 text-sm text-slate-500">{data.subtitle}</p>}
        <button onClick={close} className="mt-5 w-full bg-primary hover:bg-primary-hover text-white font-semibold rounded-xl py-2.5 transition-colors">{data.cta || "Entendido"}</button>
      </motion.div>
    </div>
  );
}
